<!-- Search Overlay Modal -->
<!-- Command palette for quick navigation and search -->
<div class="overlay-backdrop" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="search-container">
    <!-- Search Header with Input -->
    <div class="search-header">
      <!-- Search icon (hidden when drilled down) -->
      <svg
        *ngIf="!selectedParent"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="search-icon"
      >
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>

      <!-- Breadcrumb chip when drilled down -->
      <div class="search-chip" *ngIf="selectedParent">
        <span class="chip-label">{{ selectedParent.label }}</span>
      </div>

      <input
        type="text"
        #searchInput
        [placeholder]="selectedParent ? '' : 'Type to search'"
        [(ngModel)]="searchTerm"
        autoFocus
      />
    </div>

    <div class="search-results">
      <div
        class="result-item"
        *ngFor="let item of filteredItems; let i = index"
        [class.selected]="i === selectedIndex"
        (click)="selectItem(item)"
        (mouseenter)="selectedIndex = i"
      >
        <div class="item-icon">
          <!-- Icons based on item.icon -->
          <svg
            *ngIf="item.icon === 'grid'"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="3" width="7" height="7"></rect>
            <rect x="14" y="3" width="7" height="7"></rect>
            <rect x="14" y="14" width="7" height="7"></rect>
            <rect x="3" y="14" width="7" height="7"></rect>
          </svg>
          <svg
            *ngIf="item.icon === 'file-text'"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
          <svg
            *ngIf="item.icon === 'users'"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          <svg
            *ngIf="item.icon === 'database'"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
            <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
            <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
          </svg>
          <svg
            *ngIf="item.icon === 'layout'"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="3" y1="9" x2="21" y2="9"></line>
            <line x1="9" y1="21" x2="9" y2="9"></line>
          </svg>
          <svg
            *ngIf="item.icon === 'git-merge'"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="18" cy="18" r="3"></circle>
            <circle cx="6" cy="6" r="3"></circle>
            <path d="M6 21V9a9 9 0 0 0 9 9"></path>
          </svg>
          <svg
            *ngIf="item.icon === 'code'"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="16 18 22 12 16 6"></polyline>
            <polyline points="8 6 2 12 8 18"></polyline>
          </svg>
        </div>
        <span class="item-label">{{ item.label }}</span>
        <span class="item-date" *ngIf="item.date">{{ item.date }}</span>

        <!-- Only show shortcut if NOT drilled down, or maybe show Enter? -->
        <span class="item-shortcut" *ngIf="!selectedParent && item.shortcut">
          {{ item.shortcut }}
        </span>
        <span class="item-shortcut" *ngIf="selectedParent">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="9 10 4 15 9 20"></polyline>
            <path d="M20 4v7a4 4 0 0 1-4 4H4"></path>
          </svg>
        </span>
      </div>
    </div>

    <div class="search-footer">
      <div class="footer-hint"><span class="key-icon">↑↓</span> <span>Navigate</span></div>
      <div class="footer-hint" *ngIf="!selectedParent"><span class="key-icon">Tab</span> <span>Select</span></div>
      <div class="footer-hint" *ngIf="selectedParent"><span class="key-icon">⌫</span> <span>Back</span></div>
      <div class="footer-hint"><span class="key-icon">↵</span> <span>Open</span></div>
      <div class="footer-hint"><span class="key-icon">Esc</span> <span>Close</span></div>
    </div>
  </div>
</div>
